// kp-countdown.js
window.KPCountdown = (function () {
  let intervalId = null;

  function fmt(ms) {
    if (ms <= 0) return { expired: true, text: "0d 0h 0m" };
    const totalMin = Math.floor(ms / 60000);
    const days = Math.floor(totalMin / (60*24));
    const hours = Math.floor((totalMin % (60*24)) / 60);
    const mins = totalMin % 60;
    return { expired: false, text: `${days}d ${hours}h ${mins}m` };
  }

  function renderAll() {
  const now = Date.now();
  const endingSoonMs = 3 * 24 * 60 * 60 * 1000; // 3 days

  document.querySelectorAll('.po-badge--countdown').forEach(el => {
    const ts = parseInt(el.getAttribute('data-preorder-end-ts'), 10);
    if (!ts) return;

    const diff = ts * 1000 - now;
    const active = el.getAttribute('data-active-text') || 'Ends in';
    const endingSoon = el.getAttribute('data-ending-text') || '⏳ Ending soon';
    const expired = el.getAttribute('data-expired-text') || 'Pre-order closed';

    const out = fmt(diff);

    if (out.expired) {
      el.textContent = expired;
      el.classList.add('is-expired');
      el.classList.remove('is-ending-soon');
      el.setAttribute('aria-label', expired);
    } else if (diff <= endingSoonMs) {
      el.textContent = `${endingSoon} ${out.text}`;
      el.classList.add('is-ending-soon');
      el.classList.remove('is-expired');
      el.setAttribute('aria-label', `${endingSoon} ${out.text}`);
    } else {
      el.textContent = `${active} ${out.text}`;
      el.classList.remove('is-expired', 'is-ending-soon');
      el.setAttribute('aria-label', `${active} ${out.text}`);
    }
  });
}

  function start() {
    if (intervalId) return;
    renderAll();
    intervalId = setInterval(renderAll, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', renderAll);
  document.addEventListener('shopify:section:reorder', renderAll);
  document.addEventListener('shopify:block:select', renderAll);

  return { renderAll, start };
})();
